import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import EssayDefault from './Default';
import EssayPlayful from './Playful';
import EssayPlayfulTeacher from './PlayfulTeacher';

export function Essay(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();
  const isPlayfulTeacherTheme = usePlayfulTeacher();

  if (isPlayfulStudentTheme) return <EssayPlayful {...props} />;
  if (isPlayfulTeacherTheme) return <EssayPlayfulTeacher {...props} />;
  return <EssayDefault {...props} />;
}
